import { render, staticRenderFns } from "./AccontInfo.vue?vue&type=template&id=04655d86"
import script from "./AccontInfo.vue?vue&type=script&lang=js"
export * from "./AccontInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports